import {
  gspx,
  GPX_EVENT_TYPES,
  GPX_CAPABILITIES,
  GPX_ROUTES,
  GPX_FEATURES,
  GPX_PARTNERS,
} from '@rsos/gainsight';

// Event names specific to RCS to 911
const RCS_EVENT_NAMES = {
  ACCEPT: 'accept_rcs_chat',
  ACCEPT_RESPONSE: 'accept_rcs_chat_response',
  SHOW_CHAT_BOX: 'show_rcs_chat_box',
  HIDE_CHAT_BOX: 'hide_rcs_chat_box',
  SHOW_LIVE_CHAT: 'show_rcs_live_chat',
};

/**
 * Tracks when a user accepts an RCS chat request
 * @param {Object} params
 * @param {string} params.conversationId - The unique identifier for the RCS conversation
 * @param {string} params.sessionId - The unique identifier for the session
 */
export const trackAcceptRCSChat = ({ conversationId, sessionId }) => {
  gspx.trackEvent({
    name: RCS_EVENT_NAMES.ACCEPT,
    type: GPX_EVENT_TYPES.CLICK,
    feature: GPX_FEATURES.RCS911,
    capability: GPX_CAPABILITIES.TT911,
    route: GPX_ROUTES.COMMUNICATOR,
    partner: GPX_PARTNERS.GOOGLE,
    entities: {
      conversation_id: conversationId,
      session_id: sessionId,
    },
  });
};

/**
 * Tracks the response when accepting an RCS chat request
 * @param {Object} params
 * @param {boolean} params.success - Whether the accept request was successful
 * @param {string} params.conversationId - The unique identifier for the RCS conversation
 * @param {string} params.sessionId - The unique identifier for the session
 */
export const trackAcceptRCSChatResponse = ({
  success,
  conversationId,
  sessionId,
}) => {
  gspx.trackEvent({
    name: RCS_EVENT_NAMES.ACCEPT_RESPONSE,
    type: GPX_EVENT_TYPES.API_RESPONSE,
    feature: GPX_FEATURES.RCS911,
    capability: GPX_CAPABILITIES.TT911,
    route: GPX_ROUTES.COMMUNICATOR,
    partner: GPX_PARTNERS.GOOGLE,
    entities: {
      conversation_id: conversationId,
      session_id: sessionId,
    },
    additionalKeys: {
      success,
    },
  });
};

/**
 * Tracks when a user toggles the RCS chat box
 * @param {Object} params
 * @param {boolean} params.isExpanded - Whether the chat box is being expanded or collapsed
 * @param {string} params.conversationId - The unique identifier for the RCS conversation
 * @param {string} params.sessionId - The unique identifier for the session
 */
export const trackTogglingRCSChatBox = ({
  isExpanded,
  conversationId,
  sessionId,
}) => {
  gspx.trackEvent({
    name: isExpanded
      ? RCS_EVENT_NAMES.SHOW_CHAT_BOX
      : RCS_EVENT_NAMES.HIDE_CHAT_BOX,
    type: GPX_EVENT_TYPES.CLICK,
    feature: GPX_FEATURES.RCS911,
    capability: GPX_CAPABILITIES.TT911,
    route: GPX_ROUTES.COMMUNICATOR,
    partner: GPX_PARTNERS.GOOGLE,
    entities: {
      conversation_id: conversationId,
      session_id: sessionId,
    },
  });
};

/**
 * Tracks when a user clicks on a live RCS card
 * @param {Object} params
 * @param {string} params.conversationId - The unique identifier for the RCS conversation
 * @param {string} params.sessionId - The unique identifier for the session
 */
export const trackLiveRCSCardClick = ({ conversationId, sessionId }) => {
  gspx.trackEvent({
    name: RCS_EVENT_NAMES.SHOW_LIVE_CHAT,
    type: GPX_EVENT_TYPES.CLICK,
    feature: GPX_FEATURES.RCS911,
    capability: GPX_CAPABILITIES.TT911,
    route: GPX_ROUTES.COMMUNICATOR,
    partner: GPX_PARTNERS.GOOGLE,
    entities: {
      conversation_id: conversationId,
      session_id: sessionId,
    },
  });
};
